import { enumeratedLifeCycle, readStates, updateStates } from '@/constants/lifecycle';

const themeActions = {
  APPLY_THEME: 'APPLY_THEME',
  CHOOSE_THEME: 'CHOOSE_THEME',
  CHOOSE_THEME_ERROR: 'CHOOSE_THEME_ERROR',
  CLOSE_THEMES: 'CLOSE_THEMES',
  EDIT_THEME: 'EDIT_THEME',
  EDIT_THEME_ENABLED: 'EDIT_THEME_ENABLED',
  EDIT_THEME_ENABLED_ERROR: 'EDIT_THEME_ENABLED_ERROR',
  EDIT_THEME_ERROR: 'EDIT_THEME_ERROR',
  FETCH_THEMES: 'FETCH_THEMES',
  HIDE_SAVE_THEME: 'HIDE_SAVE_THEME',
  REFRESH_THEMES: 'REFRESH_THEMES',
  SHOW_SAVE_THEME: 'SHOW_SAVE_THEME',
  SHOW_THEMES: 'SHOW_THEMES',
  SHOW_THEMES_ERROR: 'SHOW_THEMES_ERROR',
  TOGGLE_THEMES_PRESENTATION: 'TOGGLE_THEMES_PRESENTATION',
  UPDATE_ACTIVE_THEME_PROPERTIES: 'UPDATE_ACTIVE_THEME_PROPERTIES',
  UPDATE_THEME: 'UPDATE_THEME',
  UPDATE_THEME_ENABLED: 'UPDATE_THEME_ENABLED',
  UPDATE_THEME_PROPERTIES: 'UPDATE_THEME_PROPERTIES',
  UPDATE_THEMES_FILTER: 'UPDATE_THEMES_FILTER',
};

export const imageActions = {
  FETCH_IMAGES: 'FETCH_IMAGES',
  SHOW_IMAGE_ERROR: 'SHOW_IMAGE_ERROR',
  SHOW_IMAGE_SUCCESS: 'SHOW_IMAGE_SUCCESS',
};

export const themeLists = ['ribbon'];

export const themeCategories = [...themeLists, 'all'];

export const themeLifeCycle = [...enumeratedLifeCycle];

export const themeStates = {
  ...readStates,
  ...updateStates,
};

export default themeActions;
